import React, { MouseEvent } from 'react'
import { observer } from 'mobx-react'
import cx from 'classnames'
import { Icons, Icon } from './icon'
import Spinner from '@/ui/Spinner'

type FileUploadedVariant = 'light' | 'dark'
type IconType = (typeof Icons)[keyof typeof Icons]

interface FileUploadedProps {
  variant?: FileUploadedVariant
  icon: IconType
  loading?: boolean
  children: React.ReactNode
  disabled?: boolean
  onClick?: (ev: MouseEvent<HTMLButtonElement>) => void
}

const FileUploaded = ({
  variant = 'dark',
  icon,
  children,
  loading = false,
  disabled = false,
  onClick,
}: FileUploadedProps) => {
  return (
    <div className={cx('fileUploaded', variant)}>
      {loading ? <Spinner isVisible /> : <Icon size={14} name={icon} />}
      <span className="fileUploaded-text">{children}</span>
      {onClick && !loading && (
        <button
          className="fileUploaded-delete"
          onClick={onClick}
          disabled={disabled}
        >
          <Icon size={14} name="cross" />
        </button>
      )}
    </div>
  )
}

export default observer(FileUploaded)
